import { Component, Input  } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header-fabricator-rewards',
  templateUrl: './header-fabricator-rewards.component.html',
  styleUrl: './header-fabricator-rewards.component.scss',
  standalone: true,
  imports: [CommonModule]
})
export class HeaderFabricatorRewardsComponent {

  @Input() titulo: string = '';
  @Input() textoSecundario?: string;
  @Input() urlImagenHeader: string = '';

}
